import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import {
  getAllServices,
  setService,
} from "../../../store/slices/servicesSlice";

import { getAllCommercials } from "../../../store/slices/commericals";
import CommercialFormModal from "./commercialFormModal";
import Select from "react-select";
import { useDebounce } from "../../../Hooks/useDebounce";
const Commercials = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const client = useSelector((state) => state.clients?.selectedClient?.value);
  const [data, setData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSubServiceModalOpen, setSubServiceModalOpen] = useState(false);
  const [isCreateFormModalOpen, setCreateFormModalModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterSearch = useDebounce(columnFilters, 300);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [reload, setReload] = useState(false);
  const [commercialData, setCommercialData] = useState();
  const [selectedCommercial, setSelectedCommercial] = useState();

  useEffect(() => {
    getServices();
  }, []);

  const fetchData = async (payload) => {
    const sortField = sorting.length > 0 ? sorting[0].id : undefined;
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? "desc" : "asc") : undefined;
    
    let queryPayload = {
      limitData: pageSize,
      limit: pageSize,
      offset: page * pageSize,
      ...(sortField && { sortBy: sortField }),
      ...(sortOrder && { sortOrder: sortOrder }),
      ...payload,
    };

    let data = await dispatch(getAllCommercials(queryPayload));
    if (data?.payload) {
      console.log("commercials", data.payload);
      setCommercialData(data.payload.data);
      setData(data.payload.data || data.payload || [])
      setCount(data.payload.count || 0);
      setReload(!reload);
    }
  };

  useEffect(() => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  }, [dispatch, page, pageSize, debouncedSearch, columnFilterSearch, sorting]);

  const getCommericalsData = () => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  };

  const getServices = async () => {
    dispatch(getAllServices());
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "ID",
        header: "ID",
        size: 150,
      },
      {
        accessorKey: "serviceName",
        header: "Service Name",
        size: 150,
      },
      {
        accessorKey: "subServiceName",
        header: "Sub Service Name",
        size: 150,
      },
      {
        accessorKey: "categoryName",
        header: "Category Name",
        size: 150,
      },
      {
        accessorKey: "planName",
        header: "Plan Name",
        size: 150,
      },
      {
        accessorKey: "service_cost",
        header: "Cost",
        size: 150,
      },
      {
        accessorKey: "service_charge",
        header: "charges",
        size: 150,
      },
      {
        accessorKey: "discount_type",
        header: "% Type",
        size: 150,
      },
      {
        accessorKey: "discount_value",
        header: "%",
        size: 150,
      },
      {
        accessorKey: "currency",
        header: "Currency",
        size: 150,
      },
      {
        accessorKey: "sub_type",
        header: "Sub Type",
        size: 150,
      },
      {
        accessorKey: "sub_value",
        header: "Sub Value",
        size: 150,
      },
    ],
    []
  );

  const handlePageChange = (event) => {
    const newState = typeof event === "function" ? event({ pageIndex: page, pageSize: pageSize }) : event;
    setPage(newState.pageIndex);
    setPageSize(newState.pageSize);
  };

  const handleOnChangeSearch = (value) => {
    setSearchQuery(value);
    setPage(0);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => rowAction(event, row),
      sx: {
        cursor: "pointer",
      },
    }),
    initialState: { density: "compact" },
    globalFilter: searchQuery,
    onGlobalFilterChange: handleOnChangeSearch,
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: totalCount || 0,
    onPaginationChange: handlePageChange,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      pagination: { pageIndex: page, pageSize: pageSize },
      sorting,
      columnFilters,
      globalFilter: searchQuery,
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <div className="d-flex">
        <div
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn bg-primary"
            disabled={client === "ts"}
            onClick={() => {
              setSelectedCommercial({});
              setModalOpen(true);
            }}
          >
            Create Commercial
          </button>
        </div>
      </div>
    ),
  });

  const toggle = () => {
    setSelectedCommercial({});
    setModalOpen(false);
  };

  const rowAction = (event, row) => {
    console.log(event, row, "row");
    setSelectedCommercial(row?.original);
    setModalOpen(true);
  };

  return (
    <Fragment>
      <CommercialFormModal
        isOpen={isModalOpen}
        toggle={toggle}
        commercialData={selectedCommercial}
      ></CommercialFormModal>
      <Breadcrumbs
        mainTitle="Commercials"
        parent="Commercials"
        parentPath="commercials"
        title="Commercials List"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Commercials;
